export { default } from "./Warning";
